export default __webpack_public_path__ + "static/media/land-5.529604b0.png";